import type { SxProps } from '@mui/material';
import { Box } from '@mui/material';
import { IconButton } from '@sweep-io/sweep-design';
import { ArrowLeft } from '@sweep-io/sweep-design/dist/icons/ArrowLeft';
import { DialogHeaderTextField } from './DialogHeaderTextField';
import { memo, useMemo } from 'react';

const baseCss = {
  display: 'flex',
  alignItems: 'center',
  gap: 5,
  flex: 1,
};
const stickyCss = {
  position: 'sticky',
  top: 0,
  zIndex: '10',
};

export interface CreateEditDialogHeaderBaseProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => any;
  onBackClick?: () => any;
  hideBackButton?: boolean;
  maxLength?: number;
  editDisabled?: boolean;
  errorHelperText?: string;
  isStickyHeader?: boolean;
  sx?: SxProps;
  rightSideContent?: React.ReactNode;
  rightSidePermissionContent?: React.ReactNode;
}

export const CreateEditDialogHeaderBase = memo(
  ({
    value,
    onBackClick,
    onChange,
    placeholder,
    hideBackButton,
    maxLength,
    editDisabled,
    errorHelperText,
    isStickyHeader,
    sx,
    rightSideContent,
  }: CreateEditDialogHeaderBaseProps) => {
    const compSx = useMemo(
      () => (isStickyHeader ? { ...baseCss, ...stickyCss } : baseCss),
      [isStickyHeader],
    );

    return (
      <Box sx={{ ...compSx, ...sx }}>
        <Box sx={{ display: 'flex', gap: '12px', flex: 1, alignItems: 'center' }}>
          {!hideBackButton && (
            <IconButton variant="flat" onClick={onBackClick}>
              <ArrowLeft />
            </IconButton>
          )}
          <DialogHeaderTextField
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            maxLength={maxLength}
            editDisabled={editDisabled}
            errorHelperText={errorHelperText}
          />
        </Box>
        {rightSideContent}
      </Box>
    );
  },
);

CreateEditDialogHeaderBase.displayName = 'CreateEditDialogHeaderBase';
